export const getStatusChipProps = (status) => {
  if (status === "published") return { label: "Published", color: "success" };
  if (status === "pending") return { label: "Pending", color: "warning" };
  if (status === "delete_requested") return { label: "Deletion requested", color: "error" };
  return { label: "Draft", color: "default" };
};

export const formatLastUpdated = (value) => {
  if (!value) return "N/A";
  try {
    return new Date(value).toLocaleDateString();
  } catch {
    return "N/A";
  }
};
